$(document).ready(function(){
    // Announce product filter change on the products page

    const selectedFilterCats = $('#selected-filter-cat');
    const shopAllFilter = $('.collections-sidebar-left #shopAll');
    const notShopAllfilters = $('.collections-sidebar-left .isotope-filter').not('#shopAll');
    const filteredProductList = $('#AjaxinateLoop');
    let selectedFilters = [];

    $('.collections-sidebar-left .isotope-filter').click(function() {
        const $this = $(this);
        const filterTitle = $this.text();
        let checked = $this.attr('aria-checked');

        //if shopAll selected
        if ($this.data('filter') === ".product-category--all-products") {
            selectedFilters = [];
            selectedFilterCats.text("Shop All Products");

            //aria-checked false on all other filters
            $.each(notShopAllfilters, function(i, filter) {
                filter.setAttribute('aria-checked','false')
            });
            
        }

        //if any other filter selected
        else {
            //if unchecking checked filter
            if (checked == "true") {
                const index = selectedFilters.indexOf(filterTitle);
                if (index > -1) {
                    selectedFilters.splice(index, 1);
                    selectedFilterCats.text('Shop Products: ' + selectedFilters);
                    checked = false;
                    $this.attr('aria-checked','false');
                    console.log(filterTitle, ' ', checked);
                }  
                
                if (selectedFilters.length == 0) {
                    shopAllFilter.attr('aria-checked','true');
                    selectedFilterCats.text("Shop All Products");
                }
            }

            //if checking unchecked filter
            else {
                selectedFilters.push(filterTitle);
                selectedFilterCats.text('Shop Products: ' + selectedFilters);
                checked = true;
                $this.attr('aria-checked','true');
                shopAllFilter.attr('aria-checked','false');
                console.log(filterTitle, ' ', checked);
            }    
        }

        filteredProductList.focus();

    });

});
